module.exports = __webpack_public_path__ + "static/media/mrright-logo-horiz-black.9b9c5259.png";